import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const Search = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="2 2 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 24C11.0294 24 7 19.9706 7 15C7 10.0294 11.0294 6 16 6C20.9706 6 25 10.0294 25 15C25 19.9706 20.9706 24 16 24ZM5 15C5 8.92487 9.92487 4 16 4C22.0751 4 27 8.92487 27 15C27 17.6775 26.0434 20.1316 24.4533 22.0391L29.7781 27.364C30.1687 27.7545 30.1687 28.3876 29.7781 28.7782C29.3876 29.1687 28.7545 29.1687 28.3639 28.7782L23.039 23.4533C21.1315 25.0434 18.6775 26 16 26C9.92487 26 5 21.0751 5 15Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)

export default Search
